module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": _vm.id,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "loadMeLabel",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body text-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "clas": "loader-txt"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loadingText)), _c('br'), _c('br'), _c('small', [_vm._v(_vm._s(_vm.loadingSubText))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner  fa-pulse fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a942fe4c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VALoading.vue
// module id = 740
// module chunks = 1